<template>
  <div class="Input">
    <div v-if="type == 'password'">
      <div class="input-password">
        <div>
          <label>{{title}}</label>
        </div>
        <input
          :value="value"
          @input="updateSelf($event.target.value)"
          @change="$emit('change')"
          @blur="$emit('blur')"
          :type="type"
          :placeholder="placeholder"
        />
        <i @click="e => toggle(e)" :class="`${classInputPassword} eye-password`"></i>
      </div>
    </div>
    <div v-else-if="type == 'tel'">
      <div v-if="mask">
        <div>
        <label>{{title}}</label>
      </div>
      <input
        :value="value"
        @input="updateSelf($event.target.value)"
        :type="type"
        @change="$emit('change')"
                  @blur="$emit('blur')"

        v-mask="mask"
        :placeholder="placeholder"
      />
      </div>
      <div v-else>
         <div>
        <label>{{title}}</label>
      </div>
      <input
        :value="value"
        @input="updateSelf($event.target.value)"
        :type="type"
        @change="$emit('change')"
                  @blur="$emit('blur')"

        :placeholder="placeholder"
      />
      </div>
    </div>
    <div v-else-if="type == 'textarea'">
        <div>
        <label>{{title}}</label>
      </div>
      <textarea
        :value="value"
        @input="updateSelf($event.target.value)"
                  @blur="$emit('blur')"

        :placeholder="placeholder"
        rows="2"
      ></textarea> 
    </div>
    <div v-else-if="type == 'birthdate'">
      <div>
        <label>{{title}}</label>
      </div>
       <input
        :value="value"
        @input="updateSelf($event.target.value)"
        type="tel"
        v-mask="'##/##/####'"
        :placeholder="placeholder"
      />
     
    </div>
 
    <div v-else>
        <label>{{title}}</label>
      <input
        :value="value"
        @input="updateSelf($event.target.value)"
        :type="type"
        :readonly="readonly ? true : false"
        @change="$emit('change')"
                  @blur="$emit('blur')"

        :placeholder="placeholder"
      />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: String,
    type: String,
    placeholder: String,
    value: String,
    mask: String,
    readonly: Boolean
  },
  data:() => ({
      classInputPassword: 'fa fa-eye',
  }),
  model: {
    prop: "value",
    event: "input",
  },
  methods: {
    updateSelf(name) {
      if(this.mask){
        // let aux = name.replace(/[^A-Z0-9]+/ig, "")
        this.$emit("input", name); 
      }else if(this.type == 'birthdate'){
         this.$emit("input", name.split('/')[2]+'-'+name.split('/')[1]+'-'+name.split('/')[0]); 
      }else{
        this.$emit("input", name);
      }
    },
    toggle(e) {
      if (
        e.target.parentElement.getElementsByTagName("input")[0].type ==
        "password"
      ) {
        e.target.parentElement.getElementsByTagName("input")[0].type = "text";
        this.classInputPassword = "fa fa-eye-slash";
      } else {
        e.target.parentElement.getElementsByTagName("input")[0].type =
          "password";
        this.classInputPassword = "fa fa-eye";
      }
    },
  },
};
</script>
<style scoped>

.Input{
  margin: 3px 0px;
}

.input-password {
  position: relative;
}

.input-password i {
  position: absolute;
  font-size: 15px;
  right: 10px;
  opacity: 0.4;
  top: 50%;
  transform: translate(0%, 0%);
}

label {
  font-family: "Agency FB";
  font-size: 12px;
  text-transform: uppercase;
  font-weight: bold;
  letter-spacing: 1px;
  color: black;
  margin-bottom: -10px !important;
}

input {
  width: 100%;
  font-family: "Agency FB Regular";
  border: none;
  outline: 0;
  font-size: 14px;
  background-color: white;
  border-bottom: solid 1px rgba(0, 0, 0, 0.100);
  padding: 0px 10px;

}

textarea{
  border: none;
  outline: 0;
  border-bottom: solid 2px rgba(0, 0, 0, 0.082);
  width: 100%;
  font-family: "Agency FB Regular";
  padding: 2px 0px;
  font-size: 14px;
}
</style>